import { Injectable } from '@angular/core';
import { IncidentMedicalAlertModel } from '../models/incident-medical-alert.model';
import { IncidentServiceBase } from '../services/incident-base.service';

@Injectable()
export class IncidentMedicalAlertService extends IncidentServiceBase<IncidentMedicalAlertModel> {
    constructor() {
        super('IncidentMedicalAlert', () => new IncidentMedicalAlertModel());
    }

    public getLookups() {
        return this.get('Incident/IncidentMedicalAlert/lookups');
    }
}
